import styled from "styled-components";

export const Container = styled.div`
	position: relative;
	//font-size: 1rem;
	font-size: clamp(1px, 4dvw, 1.2rem);
	margin-top: 4.5em;
	width: 100%;
	height: 12.31em;
	padding: 1.1em;
	box-sizing: border-box;
	border-radius: 16px;
	background: linear-gradient(90deg, #01babd 0%, #0189a7 100%);
	box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.25);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 0.5em;

	@media (orientation: landscape) {
		font-size: clamp(1px, 2.2dvw, 1.5rem);
		margin-top: 0.5em;
		flex-direction: row;
		height: 8em;
	}
`;

export const Title = styled.div`
	color: #fff;
	text-align: center;
	font-family: Baloo;
	font-size: 1.32em;
	font-style: normal;
	font-weight: 400;
	line-height: 1.1em;

	@media (orientation: landscape) {
		text-align: left;
	}
`;

export const SubTitle = styled.div`
	color: #fff;
	font-family: Inter;
	font-size: 0.75em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.2em;
`;

export const Icon = styled.img`
	color: #fff;
	width: 6.8em;
	height: 6.8em;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1.2em;
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5em;
`;
